import { Vue, Component } from 'vue-facing-decorator';
import { ArrowDown, User } from '@element-plus/icons-vue';
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';
import { useCookies } from "vue3-cookies";

@Component(
{
    props:
    {
        windowWidth:
        {
            type: Number,
            required: true
        },
        windowHeight:
        {
            type: Number,
            required: true
        }
    },
    components:
    {
    },
})

export default class Header extends Vue 
{
    private cookies : any | undefined;
    private userid: number = 0;
    private roleid: number = 0;
    private username: string = '';
    private userEmail: string = '';
    private userRole: string = '';
    private userlogin: boolean = false;
    private showUser: boolean = false;
	private showButton : boolean = false;
    private showMenu: boolean = false;
    private downloadingManual : boolean = false;
    private useDarkMode: boolean = false;
    private roleModel : RoleModel | undefined;
    private roleName : string = "";

    public async mounted()
    {
        // load cookies
        this.cookies = await useCookies().cookies;

        // check authentication
        this.userlogin = await AuthService.isLoggedIn();

        //this.useDarkMode = (useCookies().cookies.get('theme_dark') == 'true');

        if (this.userlogin === true)
        {
            this.userid = Number(localStorage.getItem('auth')!);
            this.roleid = Number(localStorage.getItem('roleid')!);
            this.username = localStorage.getItem('user')!.toString();
            this.userEmail = localStorage.getItem('email')!.toString();

            if (this.roleid > 0 && !localStorage.getItem('role'))
            {
                this.roleModel = await ApiService.getRole(this.roleid.toString());

                if (this.roleModel)
                {
                    this.roleName = this.roleModel.description;
                    localStorage.setItem("role", this.roleName);
                }
            }
            else
            {
                this.roleName = localStorage.getItem('role');
            }

            this.showUser = true;
            this.showButton = true;
        }
        else
        {
            AuthService.logout();
            this.$router.push('/login');
        }
    }

    public onLogoutClick()
    {
        // logout user
        AuthService.logout();
        this.userlogin = false;

        // return to login page
        this.$router.push('/login');
    }
    
    public async onManualClick()
    {
        this.downloadingManual = true;

		let data : Blob | undefined = await ApiService.downloadManual();

		if (data)
        {
            let blob : Blob = new Blob([data], {type: 'application/pdf'});
            let fileURL : string = window.URL.createObjectURL(blob);
            let fileLink : HTMLAnchorElement = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.download = `MC.health-Benutzerhandbuch.pdf`;
            document.body.appendChild(fileLink);

            fileLink.click();

            URL.revokeObjectURL(fileLink.href);
        }
		else
		{
            ElNotification(
            {
                title: 'Fehler',
                message: 'Das Benutzerhandbuch konnte nicht heruntergeladen werden.',
                type: 'error',
                offset: 10
            });
		}

        this.downloadingManual = false;
    }

    public onMessagesClick()
    {

    }

    public onSettingsClick()
    {

    }

    public onSupportClick()
    {

    }

    public onLogoClick()
    {
        this.$router.push('/');
    }

    public onUserProfileClick()
    {
        this.$router.push(`/profile`);
    }
}
